import Chart from "react-apexcharts";

const AssetStatusChart = ({ xAxis, yAxis, type }) => {
  const displayXAxis = xAxis.map((status) =>
    status?.toUpperCase() === "ACTIVE" ? "Running" : status
  );

  const barColors = xAxis.map((status) => {
    const s = status?.toUpperCase();
    if (s === "ACTIVE") return "#28a745";
    if (s === "STOP") return "#FF0000";
    return "#2362B4";
  });

  return (
    <Chart
      height={type ? (yAxis.length ? `${32 * yAxis.length + 200}px` : "100%") : 200}
      width={"100%"}
      options={{
        title: {
          text: "Asset Status",
          style: {
            fontFamily: "Nunito Sans, sans-serif",
            color: "#2362B4",
          },
        },
        noData: {
          text: "No Data Available",
          align: "center",
          verticalAlign: "middle",
          style: {
            color: "#999",
            fontSize: "14px",
            fontFamily: "Nunito Sans, sans-serif",
          },
        },
        colors: barColors,
        chart: {
          type: "bar",
          toolbar: {
            export: {
              csv: { filename: "AssetStatus" },
              svg: { filename: "AssetStatus" },
              png: { filename: "AssetStatus" },
            },
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: false,
            distributed: true,
          },
        },
        legend: { show: false },
        dataLabels: { enabled: false },
        yaxis: {
          title: { text: "Count" },
          labels: { show: type },
        },
        xaxis: {
          title: {
            text: "Status",
            style: { fontSize: "11px" },
          },
          categories: displayXAxis,
        },
      }}
      type="bar"
      series={[{ name: "Count", data: yAxis }]}
    />
  );
};

export default AssetStatusChart;
